module.exports = __webpack_public_path__ + "static/media/billQuantityBadge.c505d13f.svg";